var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"routeleaf-emblem",attrs:{"height":"45","alt":"RouteLeaf Emblem","src":require('@/assets/img/routeleaf-emblem.png')},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }